import { render, staticRenderFns } from "./card-terms.vue?vue&type=template&id=1c39fc7e&scoped=true&"
import script from "./card-terms.vue?vue&type=script&lang=js&"
export * from "./card-terms.vue?vue&type=script&lang=js&"
import style0 from "./card-terms.vue?vue&type=style&index=0&id=1c39fc7e&prod&lang=scss&scoped=true&"
import style1 from "./card-terms.vue?vue&type=style&index=1&id=1c39fc7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c39fc7e",
  null
  
)

export default component.exports